import { shoppingCartAPI } from "services/swagger-api";
import { MainBorrowerPricingSyncActions } from "../types";

export const fetchShoppingCart = async (
  borrowerProjectId: string,
  borrowerId: string,
  actions: MainBorrowerPricingSyncActions,
): Promise<void> => {
  try {
    actions.setLoading(true)
    actions.setError(null)

    if (borrowerId && borrowerProjectId) {
      const response = await shoppingCartAPI.fetchBorrowerShoppingCart({ borrowerProjectId })
      if (response.items)
        actions.updateShoppingCart(response.items)
    }
  } catch (error) {
    actions.setError(error instanceof Error ? error.message : 'Une erreur est survenue')
  } finally {
    actions.setLoading(false)
  }
}
